import { render, staticRenderFns } from "./CrimeDisclaimer.vue?vue&type=template&id=308c5b49&scoped=true&"
import script from "./CrimeDisclaimer.vue?vue&type=script&lang=js&"
export * from "./CrimeDisclaimer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "308c5b49",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
installComponents(component, {VAlert})
